export default __webpack_public_path__ + "static/media/shopshop.f67c606d.png";